import { limpiarRegistro, registrarSeccion } from './registroDeSecciones.js';

/**
 * Registro de los CINCO destinos de modulo (RF-018).
 *
 * En el incremento 1 estos destinos existen como SECCIONES VACIAS registradas:
 * la navegación completa se puede recorrer desde el primer día y cada módulo
 * posterior sustituirá su componente sin tocar el shell (RF-019).
 *
 * Etiquetas cortas vigentes (RNF-022): Movs · Cuentas · Presup · Vencen más
 * Ajustes, que lo agrega el shell al final. "Movs" está DECIDIDA por D-10: no se
 * sustituye por "Movim." ni por ninguna otra abreviatura.
 *
 * DOS CAMBIOS DEL INCREMENTO 08:
 *   * El campo `incremento` se retira de los cinco descriptores (RN-339, D-214):
 *     alimentaba un subtítulo con el número del plan de trabajo, que no es
 *     información para quien usa la aplicación. Era dato muerto además, porque su
 *     única pantalla lectora deja de montarse; se retira para que no reaparezca
 *     cuando el Tablero se construya.
 *   * El Tablero se registra con `visibleEnBarraInferior: false` (RN-357, D-220):
 *     desaparece de la barra inferior, de la barra lateral y también del menú de
 *     excedentes —que filtra por esta misma marca—, sin tocar el armazón. La
 *     sección NO se borra: conserva ruta, etiqueta e icono para que el Tablero
 *     real vuelva a la barra cambiando este único valor a true.
 */
export function registrarSeccionesDelIncremento1() {
  limpiarRegistro();

  registrarSeccion({
    clave: 'tablero',
    ruta: '/tablero',
    etiqueta: 'Tablero',
    etiquetaCorta: 'Tablero',
    icono: 'tablero',
    orden: 10,
    // INCREMENTO 14/16 · RF-208, D-309.a · EL TABLERO VUELVE A LA BARRA, y vuelve
    // PRIMERO, que es su lugar en la barra aprobada. El 08 lo había ocultado con
    // este mismo valor mientras no tenía contenido (RN-357, D-220) y dejó dicho
    // que bastaría cambiarlo a `true` cuando el Tablero real se construyera: esto
    // es ese cambio, y no hace falta tocar el armazón para nada más.
    visibleEnBarraInferior: true,
  });

  registrarSeccion({
    clave: 'movimientos',
    ruta: '/movimientos',
    etiqueta: 'Movimientos',
    // D-10: valor decidido, no sugerencia del módulo.
    etiquetaCorta: 'Movs',
    icono: 'movimientos',
    orden: 20,
    visibleEnBarraInferior: true,
  });

  registrarSeccion({
    clave: 'cuentas',
    ruta: '/cuentas',
    etiqueta: 'Cuentas y Tarjetas',
    etiquetaCorta: 'Cuentas',
    icono: 'cuentas',
    orden: 30,
    visibleEnBarraInferior: true,
  });

  registrarSeccion({
    clave: 'presupuesto',
    ruta: '/presupuesto',
    etiqueta: 'Presupuesto',
    etiquetaCorta: 'Presup',
    icono: 'presupuesto',
    orden: 40,
    visibleEnBarraInferior: true,
  });

  registrarSeccion({
    clave: 'vencimientos',
    ruta: '/vencimientos',
    etiqueta: 'Vencimientos',
    etiquetaCorta: 'Vencen',
    icono: 'vencimientos',
    orden: 50,
    visibleEnBarraInferior: true,
  });
}
